<template>
  <div class="btn-container">
    <transition name="fade">
    </transition>
    <button type="button" @click="loginWithFacebook()" class='btn btn--facebook'>
      <img src="../../assets/facebook.svg" alt="Facebook Logo" />
    </button>
  </div>
</template>

<script>
import { authenticateWithFacebook } from '@/helpers/Auth';

export default {
  name: "AuthWithFacebook",
  data: function() {
    return {
    };
  },
  methods: {
    loginWithFacebook: function() {
      authenticateWithFacebook();
    }
  }
}
</script>

<style lang="sass">
  .section__form {
    .btn--facebook {
      background-color: $faceback-blue;
      height: 46px;
    }
  }

</style>